import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'antd';
import secureLocalStorage from 'react-secure-storage';
import { homeRoute } from 'modules/utilities/utility';

// NavbarVertical's applyTheme() already sets --sidebar-accent on :root before this page renders
const ACCENT = 'var(--sidebar-accent)';

const ANIM = `
  @keyframes wSlideUp {
    from { opacity: 0; transform: translateY(18px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const QUOTES = [
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "Focus on being productive instead of busy.", author: "Tim Ferriss" },
  { text: "Small daily improvements over time lead to stunning results.", author: "Robin Sharma" },
  { text: "Don't watch the clock; do what it does. Keep going.", author: "Sam Levenson" },
  { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
  { text: "Every expert was once a beginner.", author: "Helen Hayes" },
  { text: "It always seems impossible until it's done.", author: "Nelson Mandela" },
  { text: "The future depends on what you do today.", author: "Mahatma Gandhi" },
  { text: "Do what you can, with what you have, where you are.", author: "Theodore Roosevelt" },
  { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
  { text: "Act as if what you do makes a difference. It does.", author: "William James" },
  { text: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill" },
  { text: "Hard work beats talent when talent doesn't work hard.", author: "Tim Notke" },
  { text: "Don't count the days, make the days count.", author: "Muhammad Ali" },
  { text: "The harder I work, the luckier I get.", author: "Samuel Goldwyn" },
  { text: "You miss 100% of the shots you don't take.", author: "Wayne Gretzky" },
  { text: "Whether you think you can or think you can't, you're right.", author: "Henry Ford" },
  { text: "I find that the harder I work, the more luck I seem to have.", author: "Thomas Jefferson" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "The best time to plant a tree was 20 years ago. The second best time is now.", author: "Chinese Proverb" },
  { text: "In the middle of every difficulty lies opportunity.", author: "Albert Einstein" },
  { text: "It does not matter how slowly you go as long as you do not stop.", author: "Confucius" },
  { text: "Perfection is not attainable, but if we chase perfection we can catch excellence.", author: "Vince Lombardi" },
  { text: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe" },
  { text: "Don't wait. The time will never be just right.", author: "Napoleon Hill" },
  { text: "Well done is better than well said.", author: "Benjamin Franklin" },
  { text: "The secret of success is to do the common thing uncommonly well.", author: "John D. Rockefeller" },
  { text: "I never dreamed about success, I worked for it.", author: "Estée Lauder" },
  { text: "Motivation is what gets you started. Habit is what keeps you going.", author: "Jim Ryun" },
  { text: "Ambition is the path to success. Persistence is the vehicle you arrive in.", author: "Bill Bradley" },
  { text: "Opportunities don't happen. You create them.", author: "Chris Grosser" },
  { text: "Success usually comes to those who are too busy to be looking for it.", author: "Henry David Thoreau" },
  { text: "Don't be afraid to give up the good to go for the great.", author: "John D. Rockefeller" },
  { text: "I owe my success to having listened respectfully to the very best advice, and then going away and doing the exact opposite.", author: "G. K. Chesterton" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "If you really look closely, most overnight successes took a long time.", author: "Steve Jobs" },
  { text: "A person who never made a mistake never tried anything new.", author: "Albert Einstein" },
  { text: "You don't have to be great to start, but you have to start to be great.", author: "Zig Ziglar" },
  { text: "Success is walking from failure to failure with no loss of enthusiasm.", author: "Winston Churchill" },
  { text: "I attribute my success to this: I never gave or took any excuse.", author: "Florence Nightingale" },
  { text: "The real test is not whether you avoid failure — it's whether you let it harden or shame you into inaction.", author: "Barack Obama" },
  { text: "Strive not to be a success, but rather to be of value.", author: "Albert Einstein" },
  { text: "Two roads diverged in a wood, and I took the one less traveled by.", author: "Robert Frost" },
  { text: "The mind is everything. What you think you become.", author: "Buddha" },
  { text: "An unexamined life is not worth living.", author: "Socrates" },
  { text: "Spread love everywhere you go. Let no one ever come to you without leaving happier.", author: "Mother Teresa" },
  { text: "When you reach the end of your rope, tie a knot in it and hang on.", author: "Franklin D. Roosevelt" },
  { text: "Always remember that you are absolutely unique. Just like everyone else.", author: "Margaret Mead" },
  { text: "Don't judge each day by the harvest you reap but by the seeds that you plant.", author: "Robert Louis Stevenson" },
  { text: "The best and most beautiful things in the world cannot be seen or even touched — they must be felt with the heart.", author: "Helen Keller" },
  { text: "It is during our darkest moments that we must focus to see the light.", author: "Aristotle" },
  { text: "Whoever is happy will make others happy too.", author: "Anne Frank" },
  { text: "You will face many defeats in life, but never let yourself be defeated.", author: "Maya Angelou" },
  { text: "The greatest glory in living lies not in never falling, but in rising every time we fall.", author: "Nelson Mandela" },
  { text: "In the end, it's not the years in your life that count. It's the life in your years.", author: "Abraham Lincoln" },
  { text: "Never let the fear of striking out keep you from playing the game.", author: "Babe Ruth" },
  { text: "Life is either a daring adventure or nothing at all.", author: "Helen Keller" },
  { text: "Many of life's failures are people who did not realize how close they were to success when they gave up.", author: "Thomas Edison" },
  { text: "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose.", author: "Dr. Seuss" },
  { text: "If life were predictable it would cease to be life, and be without flavor.", author: "Eleanor Roosevelt" },
  { text: "If you look at what you have in life, you'll always have more.", author: "Oprah Winfrey" },
  { text: "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.", author: "James Cameron" },
  { text: "Life is not measured by the number of breaths we take, but by the moments that take our breath away.", author: "Maya Angelou" },
  { text: "If you want to live a happy life, tie it to a goal, not to people or things.", author: "Albert Einstein" },
  { text: "Never let the fear of striking out keep you from playing the game.", author: "Babe Ruth" },
  { text: "Money and success don't change people; they merely amplify what is already there.", author: "Will Smith" },
  { text: "Your time is limited, so don't waste it living someone else's life.", author: "Steve Jobs" },
  { text: "Not how long, but how well you have lived is the main thing.", author: "Seneca" },
  { text: "If you're not positive energy, you're negative energy.", author: "Mark Cuban" },
  { text: "Courage is what it takes to stand up and speak; courage is also what it takes to sit down and listen.", author: "Winston Churchill" },
  { text: "Definiteness of purpose is the starting point of all achievement.", author: "W. Clement Stone" },
  { text: "Nothing in life is to be feared, it is only to be understood.", author: "Marie Curie" },
  { text: "In this life we cannot do great things. We can only do small things with great love.", author: "Mother Teresa" },
  { text: "Only a life lived for others is a life worthwhile.", author: "Albert Einstein" },
  { text: "The purpose of our lives is to be happy.", author: "Dalai Lama" },
  { text: "You only live once, but if you do it right, once is enough.", author: "Mae West" },
  { text: "Live in the sunshine, swim the sea, drink the wild air.", author: "Ralph Waldo Emerson" },
  { text: "Go confidently in the direction of your dreams! Live the life you've imagined.", author: "Henry David Thoreau" },
  { text: "When I stand before God at the end of my life, I would hope that I would not have a single bit of talent left.", author: "Erma Bombeck" },
  { text: "Happiness is not something ready made. It comes from your own actions.", author: "Dalai Lama" },
  { text: "First, have a definite, clear practical ideal — a goal, an objective.", author: "Aristotle" },
  { text: "If you can dream it, you can achieve it.", author: "Zig Ziglar" },
  { text: "You've got to get up every morning with determination if you're going to go to bed with satisfaction.", author: "George Lorimer" },
  { text: "To live is the rarest thing in the world. Most people just exist.", author: "Oscar Wilde" },
  { text: "Be yourself; everyone else is already taken.", author: "Oscar Wilde" },
  { text: "Great minds discuss ideas; average minds discuss events; small minds discuss people.", author: "Eleanor Roosevelt" },
  { text: "I have not failed. I've just found 10,000 ways that won't work.", author: "Thomas Edison" },
  { text: "If you do what you always did, you will get what you always got.", author: "Anonymous" },
  { text: "Dreaming, after all, is a form of planning.", author: "Gloria Steinem" },
  { text: "It's kind of fun to do the impossible.", author: "Walt Disney" },
  { text: "Learning never exhausts the mind.", author: "Leonardo da Vinci" },
  { text: "Limitations live only in our minds. But if we use our imaginations, our possibilities become limitless.", author: "Jamie Paolinetti" },
  { text: "Everything you've ever wanted is on the other side of fear.", author: "George Addair" },
  { text: "It is not the strongest of the species that survives, nor the most intelligent; it is the one most adaptable to change.", author: "Charles Darwin" },
  { text: "Give me six hours to chop down a tree and I will spend the first four sharpening the axe.", author: "Abraham Lincoln" },
  { text: "Genius is one percent inspiration and ninety-nine percent perspiration.", author: "Thomas Edison" },
  { text: "The best revenge is massive success.", author: "Frank Sinatra" },
  { text: "People often say that motivation doesn't last. Well, neither does bathing — that's why we recommend it daily.", author: "Zig Ziglar" },
  { text: "I've missed more than 9,000 shots in my career. I've lost almost 300 games. I've failed over and over and over again. And that is why I succeed.", author: "Michael Jordan" },
  { text: "Life shrinks or expands in proportion to one's courage.", author: "Anaïs Nin" },
  { text: "Knowing is not enough; we must apply. Willing is not enough; we must do.", author: "Johann Wolfgang von Goethe" },
];


function Welcome() {
  const navigate = useNavigate();
  const firstName = secureLocalStorage.getItem('first_name') || 'there';
  const [quote] = useState(() => QUOTES[Math.floor(Math.random() * QUOTES.length)]);

  return (
    <div className="p-3">
      <style>{ANIM}</style>

      {/* Hero banner */}
      <div
        style={{
          borderRadius: 12,
          padding: '2.5rem 2.75rem',
          color: '#fff',
          background: `linear-gradient(120deg, #344050 0%, ${ACCENT} 100%)`,
          position: 'relative',
          overflow: 'hidden',
          animation: 'wSlideUp .45s ease both',
        }}
      >
        <div style={{ position: 'absolute', width: 260, height: 260, borderRadius: '50%', filter: 'blur(60px)', background: 'rgba(255,255,255,.08)', right: -60, top: -80, pointerEvents: 'none' }} />
        <div style={{ fontSize: '.75rem', fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', opacity: .75, marginBottom: '.4rem' }}>
          Traya CRM Portal
        </div>
        <h2 style={{ fontWeight: 800, fontSize: '2rem', color: '#fff', margin: '.15rem 0 .5rem' }}>
          Welcome back, {firstName}
        </h2>
        <p style={{ opacity: .85, marginBottom: '1.6rem', maxWidth: '55ch' }}>
          You're all set. Jump straight into your workspace whenever you're ready.
        </p>
        <Button
          size="large"
          style={{ background: '#fff', color: ACCENT, border: 0, fontWeight: 700 }}
          onClick={() => navigate(homeRoute(), { replace: true })}
        >
          Continue to your workspace &rarr;
        </Button>
      </div>

      {/* Quote */}
      <Card
        size="small"
        className="mt-3"
        bodyStyle={{ padding: '1.25rem 1.5rem' }}
        style={{ animation: 'wSlideUp .45s ease both', animationDelay: '.15s', opacity: 0, animationFillMode: 'forwards' }}
      >
        <div className="d-flex gap-3 align-items-start">
          <span style={{ fontSize: '2rem', lineHeight: 1, color: ACCENT, fontWeight: 800, flexShrink: 0 }}>&ldquo;</span>
          <div>
            <div style={{ fontStyle: 'italic', color: '#3a4330', fontSize: '.95rem' }}>{quote.text}</div>
            <div style={{ color: ACCENT, fontWeight: 600, marginTop: '.3rem', fontSize: '.82rem' }}>&mdash; {quote.author}</div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default Welcome;
